import { createAction, props } from '@ngrx/store';
import { IOfferData } from '@partners/api';

export class OfferActions {
  static load = createAction('[offer] Load');
  static submit = createAction('[offer] Submit');
  static loadSuccess = createAction('[offer] Load Success', props<{ data: IOfferData }>());
  static submitSuccess = createAction('[offer] Submit Success', props<{ data: IOfferData }>());
  static submitFailure = createAction('[offer] Submit Failure', props<{ error: any }>());
}
